import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  hasPaid: false,
  purchasedBookIds: [],
  loading: false,
  error: null,
};

const HasPaidSlice = createSlice({
  name: "hasPaid",
  initialState,
  reducers: {
    fetchHasPaidRequest: (state) => {
      state.loading = true;
    },
    fetchHasPaidSuccess: (state, action) => {
      state.hasPaid = action.payload.has_paid;
      state.purchasedBookIds = action.payload.purchased_books;
      state.loading = false;
    },
    fetchHasPaidFailure: (state, action) => {
      state.error = action.payload;
      state.loading = false;
    },
  },
});

export const { fetchHasPaidRequest, fetchHasPaidSuccess, fetchHasPaidFailure } =
  HasPaidSlice.actions;

export default HasPaidSlice.reducer;
